import { View } from './view'

export const PageLayoutBrokerSign = View
